export default [
  {
    path: '/materiais',
    name: 'Materiais',
    meta: { area: 'materiais' },
    component: () => import('@/pages/materiais/Materiais'),
    children: [

      // Campanhas
      {
        path: 'campanhas',
        name: 'Materiais.Campanhas',
        meta: {
          descricao: 'Campanhas'
        },
        component: () => import('@/pages/materiais/campanhas/Campanhas')
      },

      // Layouts
      {
        path: 'layouts',
        name: 'Materiais.Layouts',
        meta: { descricao: 'Layouts' },
        component: () => import('@/pages/materiais/layouts/Layouts'),
        children: [
          {
            path: '/',
            name: 'Materiais.Layouts.ListLayouts',
            meta: { descricao: 'Layouts' },
            component: () => import('@/pages/materiais/layouts/ListLayouts')
          },{
            path: 'create/image',
            name: 'Materiais.Layouts.CreateImage',
            meta: { descricao: 'Layout Image' },
            component: () => import('@/pages/materiais/layouts/image/CreateLayoutImage')
          },{
            path: 'edit/image',
            name: 'Materiais.Layouts.EditImage',
            meta: { descricao: 'Layout Image' },
            component: () => import('@/pages/materiais/layouts/image/EditLayoutImage')
          },{
            path: 'create/pdf',
            name: 'Materiais.Layouts.CreatePdf',
            meta: { descricao: 'Layout PDF' },
            component: () => import('@/pages/materiais/layouts/pdf/CreateLayoutPdf')
          },{
            path: 'edit/pdf',
            name: 'Materiais.Layouts.EditPdf',
            meta: { descricao: 'Layout PDF' },
            component: () => import('@/pages/materiais/layouts/pdf/EditLayoutPdf')
          }
        ]
      },

      /* Arquivos */
      /*Desativado temporariamente*/
      {
        path: 'arquivos',
        name: 'Materiais.Arquivos',
        meta: {
          descricao: 'Arquivos'
        },
        component: () => import('@/pages/materiais/arquivos/Arquivos'),
        children: [
          {
            path: '/',
            name: 'Materiais.Arquivos.ListArquivos',
            meta: { descricao: 'Arquivos' },
            component: () => import('@/pages/materiais/arquivos/ListArquivos')
          },{
            path: 'image/layout',
            name: 'Materiais.Arquivos.ImagemLayout',
            meta: { descricao: 'Imagem Layout' },
            component: () => import('@/pages/materiais/arquivos/image/ImageLayout')
          },{
            path: 'video/upload',
            name: 'Materiais.Arquivos.VideoUpload',
            meta: { descricao: 'Video Upload' },
            component: () => import('@/pages/materiais/arquivos/videos/VideoUpload')
          },{
            path: 'image/upload',
            name: 'Materiais.Arquivos.ImageUpload',
            meta: { descricao: 'Image Upload' },
            component: () => import('@/pages/materiais/arquivos/image/ImageUpload')
          },{
            path: 'pdf/upload',
            name: 'Materiais.Arquivos.PdfUpload',
            meta: { descricao: 'PDF Upload' },
            component: () => import('@/pages/materiais/arquivos/pdf/PdfUpload')
          },{
            path: 'pdf/layout',
            name: 'Materiais.Arquivos.PdfLayout',
            meta: { descricao: 'PDF Layout' },
            component: () => import('@/pages/materiais/arquivos/pdf/PdfLayout')
          }
        ]
      },





      // {
      //   path: 'arquivos/template',
      //   name: 'Materiais.ArquivoTemplate',
      //   meta: {
      //     descricao: 'Arquivos'
      //   },
      //   component: () => import('@/pages/materiais/arquivos/ArquivoTemplate')
      // },

      // /* Catalogos */
      // {
      //   path: 'catalogos',
      //   name: 'Materiais.Catalogos',
      //   meta: { descricao: 'Catalogos' },
      //   component: () => import('@/pages/materiais/catalogos/Catalogos')
      // },

      /* Scripts */
      {
        path: 'scripts',
        name: 'Materiais.Scripts',
        meta: {
          descricao: 'Scripts'
        },
        component: () => import('@/pages/materiais/scripts/Scripts')
      }
    ]
  },
]
